import usePriceRangeFilterManager from '@/src/hooks/srp/priceRangeFilterManager'
import { Box, Divider } from '@mui/material'
import PriceRangeFilter from './priceRangeFilter'

const PriceRangeFilterWrapper = () => {
    const { min, max, changePriceRange, title, currentMax, currentMin } = usePriceRangeFilterManager()

    // if (min && max && currentMin && currentMax)
    return (
        <Box sx={{ width: '100%' }}>
            <Divider />
            <PriceRangeFilter
                minPrice={min || 0}
                maxPrice={max || 0}
                onPriceChange={changePriceRange}
                title={title}
                key={`${min}-${max}`}
                currentMax={currentMax || 0}
                currentMin={currentMin || 0}
            />
            <Divider />
        </Box>
    )

    // return null
}

export default PriceRangeFilterWrapper
